import { useContext } from 'react';
import { AttachmentIcon, FILE_TYPES } from '@zg-rentals/satellite-components';
import { Checkbox, Label, LabeledControl, Text } from '@zillow/constellation-10';
import { AppContext } from '../../../../../contexts/AppContextProvider';
import type { HandleSelectAttachmentToDelete } from '../../index';
import { isZillow } from '@zg-rentals/multibrand-support';

type Props = {
  fileName: string;
  fileType: string;
  imageSrc: string;
  onSelect: HandleSelectAttachmentToDelete;
  zDocId: string;
};

const AttachmentCardSelector = ({ fileName, fileType, imageSrc, onSelect, zDocId }: Props) => {
  const { brand, isImpersonator } = useContext(AppContext);
  const isZDocPreviewUrl = imageSrc.includes('zillowdocs') && imageSrc?.includes('/image/preview');
  const imageSrcResized = isZDocPreviewUrl ? `${imageSrc}&height=${48}&width=${48}` : imageSrc;
  const isImageFileType = fileType?.includes(FILE_TYPES.IMAGE) ?? false;
  const isVideoFileType = fileType?.includes(FILE_TYPES.VIDEO) ?? false;
  const isZillowBrand = isZillow(brand);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onSelect(e.target.value, e.target.checked);
  };

  return (
    <LabeledControl
      css={{
        borderRadius: '4px',
        marginTop: 'tighter',
        paddingLeft: 'tighter',
        display: 'flex',
        alignItems: 'center',
        '& input[type="checkbox"]': { marginBlockStart: 0 },
        background: isZillowBrand ? '{colors.gray.100}' : '{colors.hotpads.gray.100}',
        border: isZillowBrand ? '1px solid {colors.gray.300}' : '1px solid {colors.hotpads.gray.500}',
      }}
      control={<Checkbox value={zDocId} onChange={handleChange} />}
      label={
        <Label
          css={{ display: 'flex', alignItems: 'center', paddingRight: 'tighter', width: '100%', overflowX: 'hidden' }}
        >
          <AttachmentIcon
            isImageFileType={isImageFileType}
            isVideoFileType={isVideoFileType}
            isDisabled={!imageSrc || isImpersonator}
            imageSrc={imageSrcResized}
          />
          <Text
            textStyle="body-sm"
            css={{
              truncate: true,
              display: 'inline-block',
              verticalAlign: 'middle',
              maxWidth: '100%',
              marginLeft: 'default',
              marginRight: 'default',
            }}
          >
            {fileName}
          </Text>
        </Label>
      }
    />
  );
};

export default AttachmentCardSelector;
